import React from 'react';

export default function DivTagPermission(props) {
    return ( !props.hidden && (<div {...props}>{props.children}</div>)
    )
}
